import { createRouter, createWebHistory } from 'vue-router';
// import HelloWorld from '@/components/HelloWorld.vue'

// console.log(import.meta)
export const Layout = () => import('@/layout/index.vue');
const activeIndex = useStorage('activeIndex', "/", sessionStorage);
export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  meta: {
    hidden: true
  },
  children: [{
    path: '/redirect/:path(.*)',
    component: () => import('@/views/redirect/index.vue')
  }]
}, {
  path: '/',
  name: '/',
  component: Layout,
  redirect: `/${activeIndex.value == '/' ? 'dashboard' : activeIndex.value}/`,
  children: [{
    path: 'dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    name: 'dashboard',
    meta: {
      title: '首页',
      icon: 'sy',
      affix: true,
      keepAlive: true,
      head: true
    }
  }, {
    path: '/dashboard/notify',
    name: 'notify',
    component: () => import('@/views/dashboard/notify/index.vue')
  }, {
    path: '/question_resource',
    name: 'question_resource',
    component: () => import('@/views/resource/index.vue')
  }, {
    path: '/preview_paper',
    name: 'preview_paper',
    component: () => import('@/views/preview/index.vue')
  }, {
    path: '/student/:pathMatch(.*)*',
    name: 'student',
    meta: {},
    component: () => import('@/components/SubContainer.vue')
  },
  // {
  //     path: '/exploit/:pathMatch(.*)*',
  //     name: 'exploit',
  //     meta: {},
  //     component: () => import('@/components/SubContainer.vue')
  // },
  {
    path: '/teaching/:pathMatch(.*)*',
    name: 'teaching',
    meta: {},
    component: () => import('@/components/SubContainer.vue')
  },
  // {
  //     path: '/teaching',
  //     name: 'teaching',
  //     meta: {},
  //     component: () => import('@/views/error/exploit.vue')
  // },
  {
    path: '/homework/:pathMatch(.*)*',
    name: 'homework',
    meta: {},
    component: () => import('@/components/SubContainer.vue')
  }, {
    path: '/evaluate/:pathMatch(.*)*',
    name: 'evaluate',
    meta: {},
    component: () => import('@/components/SubContainer.vue')
  }, {
    path: '/diagnosis',
    name: 'diagnosis',
    meta: {},
    component: () => import('@/views/error/exploit.vue')
  }]
},
// {
//     path: '/resource',
//     name: '/resource',
//     component: Layout,
//     redirect: 'resource/qresource',
//     children: [
//         {
//             path: '/qresource',
//             name: 'resourcepage',
//             component: () => import('@/views/resource/index.vue'),
//         },
//     ]
// },
// {
//     path: '/question_resource',
//     name: 'question_resource',
//     component: () => import('@/views/resource/index.vue'),
// },
// {
//     path: '/home',
//     name: '/home',
//     component: Layout,
//     redirect: '/',
//     children: [
//         {
//             path: '/home',
//             name: 'homepage',
//             component: () => import('@/views/home/index.vue'),
//         },
//     ]
// },
{
  path: '/login',
  name: 'login',
  component: () => import('../views/login/index.vue')
}
// {
//   path: '/about',
//   name: 'about',
//   component: () => import('../views/AboutView.vue'),
// },
];
const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL || '/'),
  history: createWebHistory('/'),
  routes: constantRoutes
});
export default router;